export const selectPayHistory = {
	list: (state) => state.payment_history.list,
	fetch: (state) => state.payment_history.fetch,
	params: (state) => state.payment_history.params,
	isFinal: (state) => state.payment_history.isFinal,
	total: (state) => state.payment_history.total,
};
